import {IRegionDto} from '../model/types';

export const getRegionFromSubsectionCode = (
    subsectionCode: string,
    regions: IRegionDto[],
) => regions && regions
    ?.find(({subregionList}) => subregionList
        ?.some(subregion => subregion.code === subsectionCode));

export const getRegionFromRegionCode = (
    regionCode?: string,
    regions?: IRegionDto[],
) => regions && regions?.find(region => region.regionCode === regionCode);
